// The backend sends the housemate count as a label such as "5+"; plural rules need a number.
export function housematesPluralCount(roommatesCount: string | undefined): number {
  return Number.parseInt(roommatesCount ?? '', 10) || 0;
}

export function buildListingPhotoAlt(
  displayName: string | undefined,
  caption: string | undefined,
  index: number,
): string {
  if (caption) return caption;
  if (displayName) return `${displayName} — Photo ${index + 1}`;
  return `Property photo ${index + 1}`;
}
